exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.in[data-v-7a38dad6] {\n    display: block;\n}\n", ""]);

// exports
